import config from '../config';
import posthog from 'posthog-js';

export const apiCode = withAmpersand => {
    // Live with ampersand
    // Live without ampersand
    // Dev with ampersand
    // Dev without ampersand
    return config.apiGateway.CODE
        ? withAmpersand
            ? `?code=${config.apiGateway.CODE}&`
            : `?code=${config.apiGateway.CODE}`
        : withAmpersand
        ? '?'
        : '';
};

export const apiConfig = (guid, files, immutable, cancelToken) => {
    return {
        cancelToken,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Cache-Control': immutable ? 'max-age=3600' : 'no-cache',
            token: guid ? guid : '',
            'Content-Type': files ? 'multipart/form-data' : 'application/json',
        },
    };
};

export const apiGet = (url, guid, success, failure, returnText, overrideHeaders) => {
    const baseHeaders = apiConfig(guid);
    if (overrideHeaders) baseHeaders.headers = overrideHeaders;
    const headers = { ...baseHeaders, method: 'GET' };
    const codePrefix = url.indexOf('?') > 0 ? '&' : '?';

    const fullUrl =
        url.indexOf('http') >= 0 ? url : `${config.apiGateway.URL}${url}${codePrefix}code=${config.apiGateway.CODE}`;

    return fetch(fullUrl, headers)
        .then(res => (returnText ? res.text() : res.json()))
        .then(response => success?.(response))
        .catch(err => (failure ? failure(err) : console.error(err)));
};

export const apiPost = (url, object, guid, success, failure, method, returnType, extraHeaders) => {
    const headers = {
        ...extraHeaders,
        ...apiConfig(guid),
        method: method || 'POST',
        body: object ? JSON.stringify(object) : null,
    };

    const codePrefix = url.indexOf('?') > 0 ? '&' : '?';

    return fetch(`${config.apiGateway.URL}${url}${codePrefix}code=${config.apiGateway.CODE}`, headers)
        .then(res => {
            return returnType === 'text' ? res.text() : returnType === 'json' ? res.json() : res;
        })
        .then(response => {
            if (response?.ok || typeof response?.ok === 'undefined') {
                success?.(response);
            } else {
                if (response?.status === 409) {
                    posthog.capture('data-conflict', { url: url, data: object });
                }
                failure?.({ response });
            }
        })
        .catch(err => failure?.(err));
};

export const apiPatch = (url, object, guid, success, failure, method, returnType, extraHeaders) => {
    apiPost(url, object, guid, success, failure, method || 'PATCH', returnType, extraHeaders);
};

export const apiDelete = (url, object, guid, success, failure, method, returnType, extraHeaders) => {
    apiPost(url, object, guid, success, failure, method || 'DELETE', returnType, extraHeaders);
};

export const apiDownloadFile = (url, object, guid, success, failure, method, extraHeaders) => {
    const headers = {
        ...extraHeaders,
        ...apiConfig(guid),
        method: method || 'POST',
        body: object ? JSON.stringify(object) : null,
    };

    const codePrefix = url.indexOf('?') > 0 ? '&' : '?';

    fetch(`${config.apiGateway.URL}${url}${codePrefix}code=${config.apiGateway.CODE}`, headers)
        .then(response => {
            if (response.ok) {
                const blob = response.blob();
                const filenameHeader = response.headers.get('Content-Disposition');
                let filename = filenameHeader?.split('filename=')[1];
                if (filename) {
                    filename = filename.trim().replace(/^"|"$/g, '');
                }

                return Promise.all([blob, filename, response]);
            }

            return Promise.all([response]);
        })
        .then(([blob, filename, response]) => {
            if (response.ok) {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const url = window.URL.createObjectURL(blob);
                a.style = 'display: none';
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);

                success?.(filename);
            } else {
                failure?.({ response });
            }
        })
        .catch(err => {
            failure?.({ err });
        });
};
